import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { ArrowUpRight } from "lucide-react";
import { MetaVerifiedBadge } from "../components/MetaVerifiedBadge";

export default function Signup() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(email, password, fullName);
      toast.success("Account created");
      nav("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Registration failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-bone grid lg:grid-cols-2">
      <div className="flex items-center justify-center p-5 sm:p-8">
        <form onSubmit={submit} className="w-full max-w-md" data-testid="signup-form">
          <Link to="/" className="font-heading font-black text-2xl tracking-tighter inline-block mb-10 sm:mb-12">InstaVibe<span className="text-klein">.</span></Link>
          <div className="overline mb-3 sm:mb-4">— Create account</div>
          <h1 className="font-heading font-black text-3xl sm:text-4xl md:text-5xl tracking-tighter mb-6 sm:mb-8 leading-tight">Start automating.</h1>
          <div className="space-y-5">
            <div>
              <label className="label-overline">Full name</label>
              <input value={fullName} onChange={(e)=>setFullName(e.target.value)} className="input-field" data-testid="signup-name" />
            </div>
            <div>
              <label className="label-overline">Email</label>
              <input type="email" value={email} onChange={(e)=>setEmail(e.target.value)} required className="input-field" data-testid="signup-email" />
            </div>
            <div>
              <label className="label-overline">Password</label>
              <input type="password" value={password} onChange={(e)=>setPassword(e.target.value)} required minLength={6} className="input-field" data-testid="signup-password" />
              <div className="text-xs text-white/50 mt-1">Min 6 characters.</div>
            </div>
            <button type="submit" disabled={loading} className="btn-primary w-full mt-2" data-testid="signup-submit">
              {loading ? "Creating…" : (<>Create account <ArrowUpRight className="w-4 h-4" /></>)}
            </button>
          </div>
          <div className="mt-8 text-sm text-white/60">Already have an account? <Link to="/login" className="font-semibold text-klein hover:text-klein-dark" data-testid="signup-goto-login">Sign in</Link></div>
          <div className="mt-8 pt-6 border-t border-white/5">
            <MetaVerifiedBadge variant="compact" />
          </div>
        </form>
      </div>
      <div className="hidden lg:flex items-center justify-center bg-klein p-12 relative overflow-hidden">
        <div className="relative z-10">
          <div className="overline text-white/60 mb-4">— Ship in 2 minutes</div>
          <div className="font-heading font-black text-5xl text-white tracking-tighter leading-[0.95] max-w-md">
            Connect. Configure. Convert.
          </div>
          <div className="mt-10 space-y-3 text-white/90 font-mono text-sm">
            <div>→ 14-day free trial</div>
            <div>→ No credit card required</div>
            <div>→ Cancel anytime</div>
          </div>
        </div>
      </div>
    </div>
  );
}
